import { Grid } from '@mantine/core';
import React from 'react';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    SystemUserRoleMutationResourceSchema,
    SystemUserRolePropertyValidation,
    SystemUserRoleResource,
    useSystemUserRoleActions,
} from '../../../../resource/resources/persistables/user/systemUserRole';
import { PropertyInputs } from '../../../reusable-components/base/property-bases/PropertyInputs';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import {
    Form_DisplayComponentBaseView,
} from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';

export const SystemUserRoleCreateAndEditDialog= ({ label, onClose, systemUserRole }: {
    systemUserRole: SystemUserRoleResource;
    label: string;
    onClose: () => void;
}) => {
    const systemUserRoleActions = useSystemUserRoleActions()

    const addRole = systemUserRoleActions.useAddResource();
    const updateRole = systemUserRoleActions.useUpdateResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: SystemUserRoleMutationResourceSchema,
        defaultValues: systemUserRole,
        submitHandler: async (data) => {
            if (data.id !== '') {
                await updateRole.mutateAsync(
                    {
                        resource: data,
                        id: data.id,
                    },
                    { onSuccess: onClose },
                );
            } else {
                await addRole.mutateAsync(data, { onSuccess: onClose },);
            }
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={label}
            resourceType={ResourceType.SYSTEM_USER_ROLE}
        >
            <Form_DisplayComponentBaseView form={form} onSubmit={onSubmit} canSubmitDefaultValue={false}>
                <Grid>
                    <Grid.Col span={6}>
                        <PropertyInputs.Name
                            name={formNames.name}
                            control={form.control}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: systemUserRole.id,
                                resourceType: ResourceType.SYSTEM_USER_ROLE,
                                propertyIdentifier: SystemUserRolePropertyValidation.NAME,
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <PropertyInputs.MultilineString
                            name={formNames.description}
                            control={form.control}
                            nullable={false}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: systemUserRole.id,
                                resourceType: ResourceType.SYSTEM_USER_ROLE,
                                propertyIdentifier: SystemUserRolePropertyValidation.DESCRIPTION,
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <PropertyInputs.Boolean
                            name={formNames.isServerAdmin}
                            control={form.control}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: systemUserRole.id,
                                resourceType: ResourceType.SYSTEM_USER_ROLE,
                                propertyIdentifier: SystemUserRolePropertyValidation.IS_SERVER_ADMIN,
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <PropertyInputs.Boolean
                            name={formNames.isAdmin}
                            control={form.control}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: systemUserRole.id,
                                resourceType: ResourceType.SYSTEM_USER_ROLE,
                                propertyIdentifier: SystemUserRolePropertyValidation.IS_ADMIN,
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <PropertyInputs.Boolean
                            name={formNames.isManagerOfAllProjects}
                            control={form.control}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: systemUserRole.id,
                                resourceType: ResourceType.SYSTEM_USER_ROLE,
                                propertyIdentifier: SystemUserRolePropertyValidation.IS_MANAGER_OF_ALL_PROJECTS,
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <PropertyInputs.Boolean
                            name={formNames.isProcessAdminOfAllProjects}
                            control={form.control}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: systemUserRole.id,
                                resourceType: ResourceType.SYSTEM_USER_ROLE,
                                propertyIdentifier: SystemUserRolePropertyValidation.IS_PROCESS_ADMIN_OF_ALL_PROJECTS,
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <PropertyInputs.Boolean
                            name={formNames.isReaderOfAllProjects}
                            control={form.control}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: systemUserRole.id,
                                resourceType: ResourceType.SYSTEM_USER_ROLE,
                                propertyIdentifier: SystemUserRolePropertyValidation.IS_READER_OF_ALL_PROJECTS,
                            }}
                        />
                    </Grid.Col>
                </Grid>
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};


